import Image from 'next/image'
import React from 'react'
import { MdAdd } from 'react-icons/md'

import bankList from '@/libs/constants/bank-list'
import { EPayoutType } from '@/libs/types/global.types'

type TAddPayoutInfo = {
  readonly type: EPayoutType
  readonly onClick?: () => void
}

export default function AddPayoutInfo({ type, onClick }: TAddPayoutInfo) {
  const unknownBank = bankList.unknown
  const infoText = type === EPayoutType?.BANK ? 'No bank account added' : 'No phone number added'

  return (
    <button
      type='button'
      className={`flex cursor-pointer
      flex-row items-center gap-2 rounded-lg border border-pop-lighter bg-white px-4 py-3`}
      onClick={onClick}
    >
      <figure className='flex flex-row items-center gap-3'>
        <Image
          src={unknownBank.src}
          width={70}
          height={50}
          alt={unknownBank.alt}
          className='h-8 w-11'
        />
        <figcaption className='flex flex-col gap-1'>
          <span className='text-xs font-bold text-pop-grey-800'>{infoText}</span>
          <span className='w-fit text-xs font-normal text-pop-grey-600'>Click here to add</span>
        </figcaption>
      </figure>
      <MdAdd className='ml-auto h-5 w-5 text-pop-blue-400' data-testid='add-payout' />
    </button>
  )
}
